import { createPathParamCRUD, createPathParam, type NoPathParams } from "@/api/shared/crud";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";
import type {
  TOrthoProposedPlan,
  TOrthoProposedPlanMarkType,
  TOrthoProposedPlanPricingOption,
} from "./types";
import { createService } from "@/api/shared/service";
export interface IOrthoProposedPlanFilter extends DefaultPaginatedFilters {
  patient?: string;
}

const SLUG = "patient/ortho-proposed-plans";
const PRICING_OPTIONS_SLUG = "patient/ortho-proposed-plans-pricing-options";

export default createService(SLUG, {
  ...createPathParamCRUD<
    TOrthoProposedPlan,
    NoPathParams,
    IOrthoProposedPlanFilter,
    Partial<TOrthoProposedPlan>,
    Partial<TOrthoProposedPlan>
  >(SLUG),

  markAs: createPathParam<
    any,
    { id: string; type: TOrthoProposedPlanMarkType },
    Record<string, never>
  >(`${SLUG}/{id}/{type}/`),

  pricingOptions: createService(PRICING_OPTIONS_SLUG, {
    ...createPathParamCRUD<TOrthoProposedPlanPricingOption>(PRICING_OPTIONS_SLUG),
  }),
});

export * from "./types";
